import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { TimeEnum } from "../../../../lib/enums";
import { FILTER_KEYWORDS } from "../../../search/consts";
import { getSearchPivotLink } from "../../util";
import { formatSourcesDataForDisplay } from "./sourcesUtils";
import { Name } from "../../../search/schema/components";

const SourceItem = ({ data }) => {
  const sourceItemData = formatSourcesDataForDisplay(data);
  const rerouteSelections = {
    time_type: FILTER_KEYWORDS.FIRST_SEEN,
    period_type: TimeEnum.LAST_MONTH
  };
  return (
    <table className="sample-sources-table">
      <colgroup>
        <col style={{ width: "30%" }} />
        <col style={{ width: "70%" }} />
      </colgroup>
      <tbody>
        {sourceItemData.map(([sourceKey, sourceValue]) => {
          const tableValue = Array.isArray(sourceValue)
            ? sourceValue.map((value, nestedIdx) => (
                <div key={nestedIdx}>{value}</div>
              ))
            : sourceValue;
          return (
            <tr key={sourceKey}>
              <td>{sourceKey}</td>
              {(() => {
                if (sourceKey === "URL") {
                  return (
                    <td>
                      <Name
                        data={{
                          file_name: tableValue,
                          int_submission_analyzer: 1
                        }}
                        className="sample-report-grid__link"
                      />
                    </td>
                  );
                } else if (sourceKey === "File Name") {
                  return (
                    <td>
                      <Link
                        to={getSearchPivotLink(
                          `filename:"${tableValue}"`,
                          rerouteSelections,
                          false,
                          "cloud"
                        )}
                        className="sample-report-grid__link"
                      >
                        {tableValue}
                      </Link>
                    </td>
                  );
                } else {
                  return <td>{tableValue}</td>;
                }
              })()}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

SourceItem.propTypes = {
  data: PropTypes.shape()
};

export default SourceItem;
